<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item v-if="triggerTypes[eventName] === 'mouse'" title="事件变量" name="1">
        <bindVariable :otherVariables="[componentVariables]" v-model="eventVariableProxy" />
      </el-collapse-item>
      <el-collapse-item title="组件动作" name="2"
        ><cx-select
          :value="moveMentTypes[movementType] === 'component' ? movementType : ''"
          @change="changeEventName"
          :selectOptions="componentMovementOptions"
          title="事件类型"
        />
      </el-collapse-item>
      <el-collapse-item title="页面动作" name="3">
        <cx-select
          :value="moveMentTypes[movementType] === 'window' ? movementType : ''"
          @change="changeEventName"
          :selectOptions="windowMovementOptions"
          title="事件类型"
        />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import bindVariable from "./bindVariable.vue"
import { windowMovement, componentMovement, moveMentTypes, triggerTypes } from "utils/event"
export default {
  components: {
    bindVariable
  },
  props: {
    eventVariables: Array,
    componentVariables: Array,
    eventMovement: String,
    movementType: String,
    eventName: String
  },
  data() {
    return {
      activeNames: [],
      windowMovementOptions: windowMovement,
      componentMovementOptions: componentMovement,
      triggerTypes,
      moveMentTypes
    }
  },
  computed: {
    eventVariableProxy: {
      get() {
        return this.eventVariables
      },
      set(val) {
        this.$emit("update:eventVariables", val)
      }
    }
  },
  methods: {
    changeEventName(movementType) {
      const eventMovement = moveMentTypes[movementType]
      this.$emit("update:eventMovement", eventMovement)
      this.$emit("update:movementType", movementType)
    }
  }
}
</script>

<style>
</style>